import React from "react";
import {
  AiFillGithub,
  AiFillInstagram,
  AiFillYoutube,
  AiOutlineArrowUp,
} from "react-icons/ai";

const Footer = () => {
  return (
    <footer>
      <div>
        <img
          src={"https://avatars.githubusercontent.com/u/94227272?v=4"}
          alt="Founder"
        />

        <h2>Suraj Dhankad</h2>
        <p>Motivation is temporary, but discipline last forever.</p>
      </div>

      <aside>
        <h2>Social Media</h2>

        <article>
          <a href="https://youtube.com/braindecoded" target={"blank"}>
            <AiFillYoutube />
          </a>
          <a href="https://www.instagram.com/suraj_dhankad" target={"blank"}>
            <AiFillInstagram />
          </a>
          <a href="https://github.com/Suraj-Dhankad2025" target={"blank"}>
            <AiFillGithub />
          </a>
        </article>
      </aside>
      <a href="#home">
        <AiOutlineArrowUp />
      </a>
    </footer>
  );
};

export default Footer;